import { dialogType } from "redux/ducks/messages/messagesTypes";

const mapFromDialogToSnippet = (dialogs: Array<dialogType>) => {
    return dialogs.slice(0,3).map(el => ({
        lastMessage: {
          text: el.text,
          idSender: el?.idSender,
          readStatus: (el?.idSender === el?.previewUserInfo.id) ? el?.readStatus : 'none'
        },
        previewUser: {
          previewUserInfo: {
            id: el.previewUserInfo.id,
            name: el.previewUserInfo.name,
          },
          mainPhoto: {
            photoSmall: el.previewUserInfo.photoSmall
          }
        }
      }));
}

export default mapFromDialogToSnippet